import {
  Flex,
  FormControl,
  FormLabel,
  Icon,
  Input as ChakraInput,
  InputGroup,
  InputProps as ChakraInputProps,
  InputRightElement,
  InputLeftElement,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { KeyboardEvent, useState } from "react";
import { AiOutlineEye, AiOutlineInfoCircle } from "react-icons/ai";
import {
  cellPhone,
  cep,
  cpf,
  cnpj,
  currencyE,
  digit,
  paymentRange,
  percentage,
  percentageRacional,
  simpleDate,
} from "../../utils";

export interface InputProps extends ChakraInputProps {
  infoTooltipLabel?: string;
  infoTooltip?: boolean;
  errors?: any;
  register?: any;
  classInput?: string;
  before?: string;
  after?: string;
  label?: string;
  labelColor?: string;
  ref?: any;
  mask?: string;
  name?: string;
  variant?: string;
  displayLabel?: boolean;
  maxLenght?: number;
  leftIcon?: any;
}

const Input = ({
  infoTooltipLabel,
  infoTooltip,
  labelColor,
  label,
  children,
  className,
  classInput,
  ref,
  register,
  leftIcon,
  errors,
  before,
  after,
  type,
  mask,
  name,
  onBlur,
  maxLenght,
  displayLabel = true,
  variant = "outline",
  ...rest
}: InputProps) => {

  const [typeInput, setTypeInput] = useState(type);

  const handleMaskInput = (e: KeyboardEvent<HTMLInputElement>) => {

    if (mask === "percentage") {
      percentage(e);
    } else if (mask === "cellphone") {
      cellPhone(e);
    } else if (mask === "digit") {
      digit(e);
    }
  };

  const handleMaskInputOnKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (mask === "currencyE") {
      currencyE(e);
      return;
    } else if (mask === "paymentRange") {
      paymentRange(e);
      return;
    } else if (mask === "percentageRacional") {
      percentageRacional(e);
      return;
    } else if (mask === "date") {
      simpleDate(e);
    } else if (mask === "cep") {
      cep(e);
    } else if (mask === "cpf") {
      cpf(e);
    } else if (mask === "cnpj") {
      cnpj(e);
    }
  };

  const handleMaskOnBlur = (e: KeyboardEvent<HTMLInputElement>) => {
    if (mask === "percentageRacional") {
      percentageRacional(e, true)
    }
  };

  return (
    <FormControl isInvalid={!!errors?.message}>
      {label && rest?.visibility !== "hidden" && (
        <FormLabel
          w="100%"
          gap="5px"
          display="flex"
          color={labelColor ? labelColor : "gray.400"}
          fontSize="12px"
          visibility={displayLabel ? "visible" : "hidden"}
        >
          {label}
          {infoTooltip && (
            <Tooltip h="100%" placement="top" hasArrow label={infoTooltipLabel}>
              <span>
                <Icon w=".8rem" color="gray.400" as={AiOutlineInfoCircle} />
              </span>
            </Tooltip>
          )}
        </FormLabel>
      )}
      <Flex justify="center" align="center">
        {before && (
          <Text fontSize="2xl" color="black">
            {before}
          </Text>
        )}
        <InputGroup>
          {leftIcon && (
            <InputLeftElement pointerEvents="none" color="gray.400">
              <Icon as={leftIcon} />
            </InputLeftElement>
          )}
          <ChakraInput
            {...rest}
            {...register}
            className={classInput}
            onKeyUp={handleMaskInput}
            onKeyDown={handleMaskInputOnKeyDown}
            onBlurCapture={handleMaskOnBlur}
            onBlur={onBlur}
            type={typeInput}
            name={name}
            maxLength={maxLenght}
            variant={variant}
            borderRadius="2px"
            pl={leftIcon ? "2.5rem" : undefined}
          />
          {mask === "percentage" && (
            <InputRightElement children={<Text>%</Text>} />
          )}

          {type === "password" && (
            <InputRightElement onClick={() => setTypeInput(typeInput === "password" ? "text" : "password")} children={<Icon as={AiOutlineEye} />} />
          )}
        </InputGroup>

        {after && (
          <Text fontSize="2xl" color="gray.400">
            {after}
          </Text>
        )}
      </Flex>
      {errors && (
        <Text color="danger" role="alert">
          {errors.message}
        </Text>
      )}
    </FormControl>
  );
};

export { Input };